<template>
  <div class="pos-page">
    <Navbar />
    <div class="page-title-area item-bg2">
      <div class="container">
        <div class="page-title-content">
          <h2>POS</h2>
          <p>Check out our POS store</p>
        </div>
      </div>
    </div>

    <section class="pos_store">
      <h4 class="title">Products</h4>
      <div class="pos_store_container">
        <div class="pos_stores">
          <div
            v-for="product in posProducts"
            :key="product.id"
            class="pos_product"
          >
            <img :src="product.image" />
            <p>{{ product.name }}</p>
            <p class="pos_title">Sale Price: ₦{{ product.sale_price }}</p>
            <p class="pos_title">Lease Price: ₦{{ product.lease_price }}</p>

            <button @click="add(product)">Add to Cart</button>
          </div>
        </div>

        <div class="cart">
          <header>
            <h4 class="cart-title">Cart</h4>
          </header>
          <div class="cart_products">
            <div
              v-for="item in cartStore.cartItems"
              :key="item.id"
              class="cart-item"
            >
              <div class="cart-prod">
                <img :src="item.image" alt="" />
                <div>
                  <p>{{ item.name }}</p>
                  <p class="price">₦{{ item.sale_price * item.quantity }}</p>
                </div>
              </div>
              <div class="qty">
                <button @click="cartStore.decreaseQty(item.id)">-</button>
                <span>{{ item.quantity }}</span>
                <button @click="cartStore.increaseQty(item.id)">+</button>
                <button
                  class="remove"
                  @click="cartStore.removeFromCart(item.id)"
                >
                  ✕
                </button>
              </div>
            </div>
          </div>

          <hr />

          <strong class="total">Total: ₦{{ total }}</strong>

          <button>
            <router-link to="/checkout" style="color: white"
              >Checkout</router-link
            >
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Navbar from "../layout/Navbar";
import { posProducts } from "../../components/pos/data";
import { useCartStore } from "../../components/pos/store/useCartStore";
export default {
  name: "POS",
  components: {
    Navbar,
  },
  data() {
    return {
      posProducts,
    };
  },

  computed: {
    cartStore() {
      return useCartStore();
    },
    total() {
      return this.cartStore.cartTotal;
    },
  },

  methods: {
    add(product) {
      this.cartStore.addToCart(product);
    },
    increaseQty(id) {
      this.cartStore.increaseQty(id);
    },
    decreaseQty(id) {
      this.cartStore.decreaseQty(id);
    },
    remove(id) {
      this.cartStore.removeFromCart(id);
    },
  },
};
</script>

<style scoped>
.pos_store .title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 24px;
  padding: 20px 40px;
}

.pos_store_container {
  display: flex;
  align-items: flex-start;
  width: 100%;
  height: 100%;
}

.pos_stores {
  width: 100%;
  padding: 20px 40px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.pos_product {
  border: 1px solid #6b728038;
  padding: 1rem;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.pos_product img {
  border: 1px solid #6b728038;
  padding: 12px;
  border-radius: 10px;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.pos_product p {
  margin: 0;
  color: black;
  font-weight: 600;
}

.pos_title {
  font-size: 20px;
}

.pos_product button,
.cart button {
  border: none;
  background: #0d6efd;
  color: white;
  border-radius: 4px;
  padding: 8px;
  cursor: pointer;
}

.cart {
  width: 100%;
  max-width: 400px;
  border-left: 1px solid #6b728038;
  height: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: calc(100vh - 300px);
}

.cart-title {
  font-size: 20px;
  font-weight: 600;
}

.cart_products {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.cart-item {
  border: 1px solid #1a1a1a2b;
  border-radius: 10px;
  overflow: hidden;
  padding: 12px;
}

.cart-prod {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 16px;
}

.cart-prod img {
  width: 120px;
  height: 120px;
  border: 1px solid #767676;
  border-radius: 8px;
}

.cart-prod p {
  margin: 0;
  color: black;
  font-weight: 500;
}

.cart-prod .price {
  font-size: 20px;
  font-weight: 600;
}

.cart-item .qty {
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 8px;
}

.cart-item .qty button {
  border: none;
  background: #0d6efd;
  color: white;
  border-radius: 4px;
  padding: 2px 8px;
  cursor: pointer;
}

.total {
  font-size: 20px;
  font-weight: 600;
}
</style>
